var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.$style.button, _vm.chosen && _vm.$style.chosen,
           _vm.small && _vm.$style.small,
           _vm.windowsWidth <=700 && _vm.$style.mobileButton]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }